export type ThemeSetting = "light" | "dark" | "system";

const KEY = "ld.theme";

export function currentThemeSetting(): ThemeSetting {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark" || v === "system") return v;
  } catch {
    // ignore
  }
  return "system";
}

function resolve(setting: ThemeSetting): "light" | "dark" {
  if (setting !== "system") return setting;
  return typeof matchMedia !== "undefined" && matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(setting: ThemeSetting) {
  try {
    localStorage.setItem(KEY, setting);
  } catch {
    // ignore
  }
  document.documentElement.dataset.theme = resolve(setting);
}

/** Map the user's `theme_appearance` (system / light / dark) to a local setting. */
export function themeFromUser(appearance: string | undefined): ThemeSetting | null {
  return appearance === "light" || appearance === "dark" || appearance === "system" ? appearance : null;
}

if (typeof matchMedia !== "undefined") {
  matchMedia("(prefers-color-scheme: dark)").addEventListener?.("change", () => {
    if (currentThemeSetting() === "system") applyTheme("system");
  });
}
